import { useSample } from "@app/pages/samples/utils/useSample";
import { OPTIONS_YES_NO } from "../iodo131/utils/constants";
import { getCommonDefaultValues } from "../utils/getCommonDefaultValues";

export const getDefaultValuesIG = (defaultPreloadValues?: any) => {
  const { currentPreparationIndex, currentCounting, currentCalculation } =
    defaultPreloadValues;

  const commonValues = getCommonDefaultValues(defaultPreloadValues);

  const currentCountingIndex =
    currentPreparationIndex?.countings?.[currentCounting?.index as number];

  const currentCalculationIndex =
    currentCountingIndex?.calculations[currentCalculation?.index as number];

  const calculation_type_report: string[] = [];
  if (currentCalculationIndex?.only_lid) {
    calculation_type_report.push("only_lid");
  } else if (currentCalculationIndex?.only_lid === undefined) {
    calculation_type_report.push("only_lid");
  }

  if (currentCalculationIndex?.report_characterization) {
    calculation_type_report.push("report_characterization");
  }
  const processingCurrent =
    useSample.getState().stateSample?.processing?.current || [];

  const dryingProcessing =
    processingCurrent && processingCurrent.length > 0
      ? processingCurrent.find((item) => item.processing_category?.id === 3)
      : undefined;

  function moveHeightToEnd(array, targetHeight) {
    return array.sort((a, b) => {
      if (a.height === targetHeight) return 1;
      if (b.height === targetHeight) return -1;
      return 0;
    });
  }

  return {
    ...commonValues,
    //preparation
    planchette: currentPreparationIndex?.planchette || null,
    planchette_with_precipitate:
      currentPreparationIndex?.planchette_with_precipitate || null,
    analysis_amount_sample: currentPreparationIndex?.amount_sample || 0,
    mg_torta: currentPreparationIndex?.mg_torta || null,
    //counting
    counting_valid_select: currentCountingIndex?.counting_valid
      ? OPTIONS_YES_NO.find(
          (option) =>
            option.value === Number(currentCountingIndex?.counting_valid)
        )
      : undefined,
    geometry_height: currentCountingIndex?.geometry_height || null,
    counting_equipment: currentCountingIndex?.equipment
      ? moveHeightToEnd(
          currentCountingIndex?.equipment,
          currentCountingIndex?.geometry_height
        )
      : undefined,
    first_counting_time: currentCountingIndex?.first_counting_time || null,

    //calculation
    calculation_equipment:
      currentCalculationIndex?.equipment ||
      currentCountingIndex?.equipment ||
      undefined,
    pico_counts_911: currentCalculationIndex?.pico_counts_911 || null,
    pico_counts_341: currentCalculationIndex?.pico_counts_341 || null,
    //detector_file: currentCalculationIndex?.detector_file || null,
    calculation_equipment_file: currentCalculationIndex?.calculation_equipment_file || null,
    calculation_detector: currentCalculationIndex?.calculation_detector || null,
    calculation_date_countig_file: currentCalculationIndex?.calculation_date_countig_file || null,
    //calculation_date_countig_file_exe: currentCalculationIndex?.calculation_date_countig_file_exe || null,
    calibration_source_certificate: currentCalculationIndex?.calibration_source_certificate || null,
    calculation_time_count: currentCalculationIndex?.calculation_time_count || null,
    calibration_efficiency_date: currentCalculationIndex?.calibration_efficiency_date || null,
    calculation_background: currentCalculationIndex?.calculation_background || null,
    calculation_library: currentCalculationIndex?.calculation_library || null,
    source_app_calculation_info_file:
      currentCalculationIndex?.source_app_calculation_info_file || null,
    source_app_calculation_info_file_2:
      currentCalculationIndex?.source_app_calculation_info_file_2 || null,
    source_app_calculation_info:
      currentCalculationIndex?.source_app_calculation_info || "GENIE",
    calculation_type_report: calculation_type_report,
    calculation_self_absorption_factor:
      currentCalculationIndex?.self_absorption_factor || "1.000",
    calculation_tsie_sample:
      currentCalculationIndex?.sqp_tsie_sample || dryingProcessing?.wet_dry,
    calculation_performance: currentCalculationIndex?.performance || "1.000",
  };
};
